<template>

  <b-col cols="12">

    <div class="main-card card p-2 h-100-header" id="container_pages">

      <div class="card-body" id="card-page">

        <slot name="breadcrumb">

        </slot>

        <b-row v-if="breadcrumb !== undefined && breadcrumb.length > 0 && breadcrumb !== null">
          <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
        </b-row>

        <t-page-title :title="title">

          <t-page-list-right-buttons @onMountAgain="onMountAgain()"
                                     :disable-edit-field="disableEditField"
                                     :disable-edit-view="disableEditView"
                                     :modal-field-enable-note="modalFieldEnableNote"
                                     :user-auth="userAuth">
            <template #add-items>
              <slot name="right-buttons-add-items"></slot>
            </template>

          </t-page-list-right-buttons>

        </t-page-title>

        <b-row>

          <b-col cols="12" class="ml-0 mr-0">

            <div class="form-inline page-list-search">

              <slot name="search">

              </slot>

            </div>

          </b-col>

        </b-row>

        <div class="mt-4">

          <t-msg :query="msgReturnQueryCode" auto-hide :gender-feminine="msgReturnGenderFeminine"
                 :title="msgResultFormTitle()"/>

          <slot>

          </slot>


        </div>

        <b-row class="mt-3">

          <b-col cols="6" v-if="totalPages > 1">
            <t-pagination @getPage="getPage" :total-pages="totalPages"></t-pagination>
          </b-col>

          <b-col :cols="totalPages === 1 ? 12 : 6" v-if="totalElements > 0" class="text-right">
            <small>Total {{ totalElements }} {{ localTitleItems }}</small>
          </b-col>

        </b-row>


      </div>

    </div>
  </b-col>

</template>
<style>
.page-list-search > .btn:not(:last-child) {
  margin-right: 1rem !important
}
</style>
<script>
import TPageListRightButtons from "@/components/template/page/t-page-list-right-buttons";

export default {
  name: 't-page-list',
  components: {TPageListRightButtons},
  props: {
    userAuth: Object,
    breadcrumb: Array,
    title: String,
    disableEditField: Boolean,
    disableEditView: Boolean,
    modalFieldEnableNote: Boolean,
    totalPages: {
      type: Number,
      default: 0
    },
    totalElements: {
      type: Number,
      default: 0
    },
    titleItems: {
      type: String,
      default: ""
    },
    msgReturnTitle: {
      type: String,
      default: ""
    },
    msgReturnGenderFeminine: Boolean,
  },
  data() {
    return {
      localTitleItems: "",
      msgReturnQueryCode: {
        codSuccess: 0,
        codError: 0,
        returnMessage: '',
      },
    }
  },
  mounted() {

    if (this.titleItems !== '') {
      this.localTitleItems = this.titleItems
    } else {

      if (this.userAuth && this.userAuth.currentPage && this.userAuth.currentPage.singularTitle) {

        const singular = this.userAuth.currentPage.singularTitle

        if ((singular.indexOf("s", singular.length - 1) === -1) && (singular.indexOf("ão", singular.length - 2) === -1)) {
          this.localTitleItems = singular + "s"
        } else {
          this.localTitleItems = singular
        }

      } else {
        this.localTitleItems = 'registros'
      }
    }

    if (this.$route.query.codSuccess) {
      this.msgReturnQueryCode.codSuccess = parseInt(this.$route.query.codSuccess)
    } else if (this.$route.query.codError) {
      this.msgReturnQueryCode.codError = parseInt(this.$route.query.codError)
    }

    if (this.$route.query.returnMessage) {
      this.msgReturnQueryCode.returnMessage = this.$route.query.returnMessage
    }

  },
  methods: {


    msgResultFormTitle() {
      return this.msgReturnTitle !== '' ? this.msgReturnTitle : this.userAuth.currentPage.singularTitle
    }
    ,

    onMountAgain() {

      let page = this.$route.query.page

      if (page === '0') {
        page = '1'
      }

      this.$emit("getPage", page, true)
    }
    ,

    getPage(page) {
      this.$emit("getPage", page)
    }
    ,

  }
  ,
  computed: {

    page() {
      return this.$route.query.page
    }
  }
  ,
  watch: {

    isLoadingPage() {

      console.log("Is loading alterado: " + this.isLoadingPage)
    }

  }
  ,
}
</script>
